export const SUBJECT_ITEMS = [
    { label: 'FMI locked', value: 'FMI locked' },
    { label: 'Account locked', value: 'Account locked' },
    { label: 'Passcode locked', value: 'Passcode locked' },
    { label: 'Blacklisted', value: 'Blacklisted' },
    { label: 'Special Tracking Request', value: 'Special Tracking Request' },
    { label: 'Other', value: 'Other' },
];
